import { instance } from "libs/api";

import {
  CompanyCommunicationLog,
  CompanyLegalDocument,
  CompanyOperationalContact,
  CompanyPeriodParams,
  CompanySla,
  CreateCommunicationLogBody,
  CreateLegalDocumentBody,
  DashboardMetricsResponse,
  DriverPerformanceResponse,
  RevenueParams,
  RevenueResponse,
  UpdateLegalDocumentBody,
  UpsertCompanySlaBody,
  UpsertOperationalContactBody
} from "./companyProfile.types";

const base = (companyId: string) =>
  `/admin/delivery-companies/${companyId}/profile`;

export const requestGetSla = (companyId: string): Promise<CompanySla | null> =>
  instance.get(`${base(companyId)}/sla`);

export const requestUpsertSla = (
  companyId: string,
  body: UpsertCompanySlaBody
): Promise<CompanySla> => instance.put(`${base(companyId)}/sla`, body);

export const requestGetContact = (
  companyId: string
): Promise<CompanyOperationalContact | null> =>
  instance.get(`${base(companyId)}/contact`);

export const requestUpsertContact = (
  companyId: string,
  body: UpsertOperationalContactBody
): Promise<CompanyOperationalContact> =>
  instance.put(`${base(companyId)}/contact`, body);

export const requestListLogs = (
  companyId: string
): Promise<CompanyCommunicationLog[]> =>
  instance.get(`${base(companyId)}/communication-logs`);

export const requestCreateLog = (
  companyId: string,
  body: CreateCommunicationLogBody
): Promise<CompanyCommunicationLog> =>
  instance.post(`${base(companyId)}/communication-logs`, body);

export const requestUpdateLog = (
  companyId: string,
  id: string,
  body: CreateCommunicationLogBody
): Promise<CompanyCommunicationLog> =>
  instance.put(`${base(companyId)}/communication-logs/${id}`, body);

export const requestDeleteLog = (
  companyId: string,
  id: string
): Promise<{ ok: true }> =>
  instance.delete(`${base(companyId)}/communication-logs/${id}`);

export const requestListDocuments = (
  companyId: string
): Promise<CompanyLegalDocument[]> =>
  instance.get(`${base(companyId)}/legal-documents`);

export const requestCreateDocument = (
  companyId: string,
  body: CreateLegalDocumentBody
): Promise<CompanyLegalDocument> =>
  instance.post(`${base(companyId)}/legal-documents`, body);

export const requestUpdateDocument = (
  companyId: string,
  id: string,
  body: UpdateLegalDocumentBody
): Promise<CompanyLegalDocument> =>
  instance.put(`${base(companyId)}/legal-documents/${id}`, body);

export const requestDeleteDocument = (
  companyId: string,
  id: string
): Promise<{ ok: true }> =>
  instance.delete(`${base(companyId)}/legal-documents/${id}`);

export const requestGetDriverPerformance = (
  companyId: string,
  params: CompanyPeriodParams
): Promise<DriverPerformanceResponse> =>
  instance.get(`${base(companyId)}/driver-performance`, { params });

export const requestGetDashboardMetrics = (
  companyId: string,
  params: CompanyPeriodParams
): Promise<DashboardMetricsResponse> =>
  instance.get(`${base(companyId)}/dashboard-metrics`, { params });

export const requestGetRevenue = (
  companyId: string,
  params: RevenueParams
): Promise<RevenueResponse> =>
  instance.get(`${base(companyId)}/revenue`, { params });
